import { createReducer } from '@reduxjs/toolkit'
import { showSnackbar, showMessage } from './snackbar.actions'
import { AlertColor } from '@mui/material'

interface SnackbarState {
  isVisible: boolean
  message: string
  type?: AlertColor
}

const initialState: SnackbarState = {
  isVisible: false,
  message: '',
  type: undefined
}

export const snackbarReducer = createReducer(initialState, builder => {
  builder.addCase(showSnackbar, (state, action) => ({
    ...state,
    isVisible: action.payload
  }))
  builder.addCase(showMessage, (state, action) => ({
    ...state,
    message: action.payload.message,
    type: action.payload.type ? action.payload.type : 'success',
    isVisible: true
  }))
})
